<template>
	<router-view></router-view>

</template>

<script>
	export default {
		created() {
		},
		data() {
			return {
				loaded: true,
				errors: []
			}
		},
		methods: {}
	}
</script>


// WEBPACK FOOTER //
// src/pages/OngoingApplications.vue